import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { useAsync, Box, Text } from '@wix/cli-ui-kit';
import type { DeploymentTopologyEnvironmentType } from '@wix/cli-astro-definitions';
import { ActionStatus } from './ActionStatus.js';
import { useUpdateDeploymentTopologyForApp } from '../../hooks/useUpdateDeploymentTopology.js';
import { RedirectLink } from '../PlatformLink/RedirectLink.js';

export const AppTopologyAndLinks: FC<{
  environment: DeploymentTopologyEnvironmentType;
  previewId: string;
  onTopologyUpdated: () => void;
}> = ({ environment, previewId, onTopologyUpdated }) => {
  const updateDeploymentTopology = useUpdateDeploymentTopologyForApp();

  const { status } = useAsync(async () => {
    await updateDeploymentTopology({
      armTag: previewId,
      environment,
    });

    onTopologyUpdated();
  }, []);

  return (
    <>
      <ActionStatus
        status={status}
        loadingText={'Updating deployment topology manifest...'}
        successText={'Deployment topology manifest updated successfully!'}
      />
      {match(status, {
        Error: () => null,
        Loading: () => null,
        Success: () => (
          <Box rowGap={1} marginY={1} flexDirection="column">
            <Text>Open the preview on:</Text>
            <Box paddingLeft={2} flexDirection="column">
              <RedirectLink platform="site" versionOverrideId={previewId} />
              <RedirectLink platform="editor" versionOverrideId={previewId} />
              <RedirectLink
                platform="dashboard"
                versionOverrideId={previewId}
              />
            </Box>
          </Box>
        ),
      })}
    </>
  );
};
